module.exports = __webpack_public_path__ + "static/tablet-ui-kit-plp-9fe57f7c7ce4c7a213a602a2c51cfcb0.png";